import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function LedgerLinesTemplate({ draft, accent }) {
  return (
    <div
      className="bg-white text-slate-900 rounded-xl p-8 shadow-2xl text-[13px] leading-[26px]"
      style={{ backgroundImage: "repeating-linear-gradient(to bottom, transparent, transparent 25px, #f1f5f9 25px, #f1f5f9 26px)" }}
      data-testid="resume-live-preview"
    >
      <h1 className="text-2xl font-bold">{draft.full_name || "Your Name"}</h1>
      {draft.target_role && <p className="text-sm font-semibold" style={{ color: accent }}>{draft.target_role}</p>}
      <p className="text-slate-500 text-[11px]">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("  •  ")}</p>

      {draft.summary && <p className="text-slate-700 mt-2">{draft.summary}</p>}

      {draft.experience.length > 0 && (
        <div className="mt-2">
          <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i}>
              <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
              <ul className="list-disc list-inside text-slate-700">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mt-2">
          <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Education</h2>
          {draft.education.map((ed, i) => <p key={i} className="text-slate-700">{ed.degree} {ed.field} — {ed.school}</p>)}
        </div>
      )}
      {draft.skills.length > 0 && (
        <div className="mt-2">
          <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Skills</h2>
          <p className="text-slate-700">{draft.skills.join(", ")}</p>
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
